import React, { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Linking,
  StyleSheet,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import { useDevice, useScreenDimensions } from "../_layout";

const TutorialLinkSection = observer(
  ({
    text,
    urlPath,
    showCloseButton = false,
    onClose,
    marginTop = 0,
    marginBottom = 0,
  }) => {
    const { t, i18n } = useTranslation();
    const { isMobile } = useDevice();
    const { screenSize } = useScreenDimensions();
    const [isViewHovered, setIsViewHovered] = useState(false);
    const [isCloseHovered, setIsCloseHovered] = useState(false);

    const handleOpenTutorial = () => {
      const isSpanish = i18n.language === "es";
      const languagePrefix = isSpanish ? "/es" : "";
      const url = `https://app.efortcoach.com/docs${languagePrefix}${urlPath}`;
      Linking.openURL(url).catch((err) =>
        console.error("Failed to open URL:", err)
      );
    };

    const handleClose = () => {
      if (onClose) {
        onClose();
      }
    };

    const isSmallScreen = screenSize === "small";

    return (
      <View
        style={[
          styles.container,
          { marginTop: marginTop, marginBottom: marginBottom },
        ]}
      >
        <LinearGradient
          colors={["rgba(244, 244, 244, 1)", "rgba(238, 238, 238, 1)"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={styles.gradient}
        >
          <View
            style={[
              isSmallScreen
                ? styles.contentContainerColumn
                : GlobalStyles.HStack,
              styles.contentContainer,
            ]}
          >
            {/* Icon and Text Row */}
            <View style={[GlobalStyles.HStack, styles.topRow]}>
              {/* Icon */}
              <View style={styles.iconContainer}>
                <Ionicons name="school" size={20} color={Colors.blackColor} />
              </View>

              {/* Text */}
              <Text style={styles.text} numberOfLines={6}>
                {t(text)}
              </Text>
            </View>

            {/* Buttons */}
            <View
              style={[
                GlobalStyles.HStack,
                styles.buttonsContainer,
                isSmallScreen && styles.buttonsContainerCentered,
              ]}
            >
              {/* View Tutorial Button */}
              <TouchableOpacity
                style={[
                  styles.viewTutorialButton,
                  { opacity: isViewHovered ? 0.8 : 1 },
                ]}
                onPress={handleOpenTutorial}
                onMouseEnter={() => !isMobile && setIsViewHovered(true)}
                onMouseLeave={() => setIsViewHovered(false)}
              >
                <Text style={styles.viewTutorialText}>
                  {t("viewTutorial-string")}
                </Text>
              </TouchableOpacity>

              {/* Close Button */}
              {showCloseButton && (
                <TouchableOpacity
                  style={[
                    styles.closeButton,
                    { opacity: isCloseHovered ? 0.6 : 1 },
                  ]}
                  onPress={handleClose}
                  onMouseEnter={() => !isMobile && setIsCloseHovered(true)}
                  onMouseLeave={() => setIsCloseHovered(false)}
                >
                  <Text style={styles.closeButtonText}>
                    {t("close-string")}
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </LinearGradient>
      </View>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    // marginVertical: 8,
    // marginHorizontal: 12,
  },
  gradient: {
    borderRadius: 14,
    borderWidth: 0.1,
    borderColor: Colors.borderColor,
    overflow: "hidden",
  },
  contentContainer: {
    padding: 16,
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  contentContainerColumn: {
    flexDirection: "column",
    alignItems: "stretch",
  },
  topRow: {
    flex: 1,
    alignItems: "center",
  },
  iconContainer: {
    marginRight: 12,
    width: 34,
    height: 34,
    backgroundColor: Colors.whiteColor,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 17,
  },
  text: {
    flex: 1,
    fontSize: 14,
    color: Colors.blackColor,
    marginRight: 12,
    // lineHeight: 20,
    fontWeight: "500",
  },
  buttonsContainer: {
    gap: 8,
  },
  buttonsContainerCentered: {
    marginTop: 12,
    justifyContent: "center",
    width: "100%",
  },
  viewTutorialButton: {
    backgroundColor: Colors.whiteColor,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 12,
    borderWidth: 0.1,
    borderColor: Colors.borderColor,
  },
  viewTutorialText: {
    fontSize: 14,
    fontWeight: "600",
    color: Colors.blackColor,
  },
  closeButton: {
    backgroundColor: "transparent",
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "rgba(116, 116, 116, 1)",
  },
  closeButtonText: {
    fontSize: 14,
    fontWeight: "400",
    color: "rgba(116, 116, 116, 1)",
  },
});

export default TutorialLinkSection;
